import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "../pages/About/About";
import Cart from "../pages/Cart/Cart";
import Checkout from "../pages/Checkout/Checkout";
import Contact from "../pages/Contact/Contact";
import Features from "../pages/Features/Features";
import Home from "../pages/Home/Home";
import PrivacyPolicy from "../pages/PolicyPages/PrivacyPolicy";
import ReturnPolicy from "../pages/PolicyPages/ReturnPolicy";
import ChangePassword from "../pages/Profile/ChangePassword";
import Profile from "../pages/Profile/Profile";
import ProductDetails from "../pages/Shop/ProductDetails";
import Reviews from "../pages/Reviews/Reviews";
import Shop from "../pages/Shop/Shop";
import MyOrders from "../pages/Profile/MyOrders";
import Wishlist from "../pages/Profile/Wishlist";
import MyAddress from "../pages/Profile/MyAddress";
import TermCondition from "../pages/PolicyPages/TermCondition";
import RefundPolicy from "../pages/PolicyPages/RefundPolicy";
import ThankYou from "../pages/ThankYou/ThankYou";
import Signin from "../pages/AuthPages/Signin";
import ForgotPasswordEmail from "../pages/AuthPages/ForgotPasswordEmail";
import ForgotPasswordOtp from "../pages/AuthPages/ForgotPasswordOtp";
import CreateNewPassword from "../pages/AuthPages/CreateNewPassword";
import Signup from "../pages/AuthPages/Signup";
import OrderDetails from "../pages/OrderDetails/OrederDetails";
import Faqs from "../pages/Faqs/Faqs";
import LatestNewsPage from "../pages/LatestNews/LatestNews";
import NewsDetails from "../pages/NewsDetails/NewsDetails";
import GalleryImages from "../pages/Gallery/GalleryImages";
import AdvancedBooking from "../pages/AdvancedBooking/AdvancedBooking";
import NewArrival from "../pages/NewArrival/NewArrival";

function PublicRoutes() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about-us" element={<About />} />
          <Route path="shop" element={<Shop />} />
          <Route path="product-details" element={<ProductDetails />} />

          <Route path="features" element={<Features />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="reviews" element={<Reviews />} />

          <Route path="profile" element={<Profile />} />
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="my-wishlist" element={<Wishlist />} />
          <Route path="my-address" element={<MyAddress />} />

          <Route path="security" element={<ChangePassword />} />

          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="return-policy" element={<ReturnPolicy />} />
          <Route path="term-condition" element={<TermCondition />} />

          {/* maaz pages starts*/}
          <Route path="thankyou" element={<ThankYou />} />
          <Route path="order-details" element={<OrderDetails />} />
          <Route path="faqs" element={<Faqs />} />
          <Route path="latest-news" element={<LatestNewsPage />} />

          <Route path="signin" element={<Signin />} />
          <Route path="signup" element={<Signup />} />
          <Route path="forgotpasswordemail" element={<ForgotPasswordEmail />} />
          <Route path="forgotpasswordotp" element={<ForgotPasswordOtp />} />
          <Route path="createnewpassword" element={<CreateNewPassword />} />

          <Route path="gallery" element={<GalleryImages />} />

          <Route path="news-details" element={<NewsDetails />} />

          {/* maaz pages ends */}

          {/* Wal Pages Start Here */}
          <Route path="advanced-booking" element={<AdvancedBooking />} />
          <Route path="new-arrival" element={<NewArrival />} />
          {/* Wal Pages End Here */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default PublicRoutes;
